mutation ADD_PARKING_SCHEDULE (
  $availableReservationTypes: [ReservationTypeEnum]
  $blackoutDates: [Date]
  $closingTime: Time!
  $endDate: Date!
  $name: String
  $notes: String
  $openingTime: Time!
  $price: Decimal!
  $priceHourly: Decimal!
  $priority: Int
  $spots: Int
  $startDate: Date!
  $surgeFactor: Decimal
  $appliesToDays: [String]!
  $zoneId: UUID!
  $priceOvernight: Decimal
  $maxConsecutiveReservationDays: Int
  ) {
  addParkingSchedule(
    availableReservationTypes: $availableReservationTypes
    blackoutDates: $blackoutDates
    closingTime: $closingTime
    endDate: $endDate 
    name: $name
    notes: $notes
    openingTime: $openingTime
    price: $price
    priceHourly: $priceHourly 
    priority: $priority
    spots: $spots 
    startDate: $startDate
    surgeFactor: $surgeFactor
    appliesToDays: $appliesToDays
    zoneId: $zoneId
    priceOvernight: $priceOvernight
    maxConsecutiveReservationDays: $maxConsecutiveReservationDays
  ) {
    success
    error
  }
}
